import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { assetUrl } from '../../lib/seo';

export const RichContent = ({ html, className = '', testId = 'rich-content' }) =>
  html ? (
    <div className={`prose prose-lg max-w-none cms-content ${className}`} data-testid={testId}
      dangerouslySetInnerHTML={{ __html: html }} />
  ) : null;

export const InternalLinks = ({ links = [], title = 'Related pages' }) => {
  const valid = links.filter((l) => l.label && l.url);
  if (!valid.length) return null;
  return (
    <nav aria-label={title} className="mt-8" data-testid="internal-links">
      <h2 className="font-heading text-lg font-semibold text-[#23265d] mb-3">{title}</h2>
      <div className="flex flex-wrap gap-2">
        {valid.map((l) =>
          l.url.startsWith('/') ? (
            <Link key={l.url} to={l.url} className="inline-flex items-center gap-1 px-4 py-2 rounded-full bg-[#23265d]/5 text-[#23265d] text-sm hover:bg-[#23265d]/10 transition-colors">
              {l.label} <ChevronRight className="w-3 h-3" />
            </Link>
          ) : (
            <a key={l.url} href={l.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 px-4 py-2 rounded-full bg-[#23265d]/5 text-[#23265d] text-sm hover:bg-[#23265d]/10 transition-colors">
              {l.label} <ChevronRight className="w-3 h-3" />
            </a>
          )
        )}
      </div>
    </nav>
  );
};

export const PageSeoContent = ({ seo }) => {
  if (!seo || !(seo.intro_html || seo.content_html || seo.image || seo.internal_links?.length)) return null;
  return (
    <section className="py-12 md:py-16 px-4 bg-white" data-testid="page-seo-content">
      <div className="max-w-4xl mx-auto">
        {seo.image && <img src={assetUrl(seo.image)} alt={seo.image_alt || ''} loading="lazy" className="w-full rounded-2xl mb-8 object-cover max-h-[420px]" />}
        <RichContent html={seo.intro_html} className="mb-6" testId="page-seo-intro" />
        <RichContent html={seo.content_html} testId="page-seo-body" />
        <InternalLinks links={seo.internal_links} />
      </div>
    </section>
  );
};
